/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseIdPhotoUrlResponseData } from './genericApiResponseIdPhotoUrlResponseData';
import type { GenericApiResponseIdPhotoUrlResponseMessage } from './genericApiResponseIdPhotoUrlResponseMessage';
import type { GenericApiResponseIdPhotoUrlResponsePagination } from './genericApiResponseIdPhotoUrlResponsePagination';
import type { GenericApiResponseIdPhotoUrlResponseError } from './genericApiResponseIdPhotoUrlResponseError';

export interface GenericApiResponseIdPhotoUrlResponse {
  data?: GenericApiResponseIdPhotoUrlResponseData;
  message?: GenericApiResponseIdPhotoUrlResponseMessage;
  pagination?: GenericApiResponseIdPhotoUrlResponsePagination;
  error?: GenericApiResponseIdPhotoUrlResponseError;
  statusCode?: number;
}
